import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/configureStore';
import KpisContainer from '../containers/company/KpisContainer';


const CompanyKpiList = props => (
  <Provider store={configureStore(props)}>
    <KpisContainer />
  </Provider>
);

export default CompanyKpiList;
